// extracted by mini-css-extract-plugin
export default {"stickyTop":"GheAnalogueTablesTab_stickyTop__wVonR","titleRow":"GheAnalogueTablesTab_titleRow__iNzfw","subHeader":"GheAnalogueTablesTab_subHeader__tH4w0"};